module.exports = __webpack_public_path__ + "img/upwork-review-2.df082d69.jpg";